import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'app/config/routes/consts';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Button } from 'shared/ui/Button';

export const FSHeader: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	return (
		<>
			<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
				<Typography variant={'h4'} color={ColorPalette.astronaut}>
					{t('integrations.title')}
				</Typography>
				<Button onClick={() => navigate(Routes.integrationsExportErrors)} size="small">
					{t('integrations.export_errors.title')}
				</Button>
			</Box>
			<Typography
				variant={'subtitle1'}
				color={ColorPalette.baliHai}
				sx={{ marginTop: '24px', maxWidth: '722px' }}
			>
				{t('integrations.description')}
			</Typography>
			<Typography
				variant={'subtitle1'}
				color={ColorPalette.baliHai}
				sx={{ marginTop: '24px', maxWidth: '722px' }}
			>
				{t('integrations.description_1')}
			</Typography>
			<Divider color={ColorPalette.periwinkle} sx={{ margin: '44px 0' }} />
		</>
	);
};
